import React from "react";
import CustomModal from "../CustomModal";
import { useNavigate } from "react-router-dom";

const LoginModal = ({ handleClose, show }) => {
  const navigate = useNavigate();

  const logoutHandler = () => {
    localStorage.clear();
    navigate("/login");
  };

  return (
    <CustomModal
      handleClose={handleClose}
      show={show}
      handleSubmit={logoutHandler}
      submitTitle="Login/SignUp"
    >
      <div style={{ position: "relative" }}>
        {/* Close button at the top right */}
        <button
          style={{
            position: "absolute",
            top: -10,
            right: 10,
            background: "transparent",
            border: "none",
            fontSize: 25,
            cursor: "pointer",
            fontWeight: 'bold'
          }}
          onClick={handleClose}
        >
          &times;
        </button>
        <div>
          <h4
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "black",
            }}
          >
            Login/SignUp <br /> to connect with the Community
            <br />
          </h4>
        </div>
        {/* Login/Signup button */}
       
      </div>
    </CustomModal>
  );
};

export default LoginModal;
